import { render, staticRenderFns } from "./pagination-component.vue?vue&type=template&id=078d7e4c&scoped=true&"
import script from "./pagination-component.vue?vue&type=script&lang=js&"
export * from "./pagination-component.vue?vue&type=script&lang=js&"
import style0 from "./pagination-component.vue?vue&type=style&index=0&id=078d7e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d7e4c",
  null
  
)

export default component.exports